export const submitForm = async (
  values: any,
  tableId: string,
  formType: string,
): Promise<{ success: boolean; data?: any; error?: string }> => {
  try {
    const res = await fetch("/api/submit-form", {
      method: "POST",
      body: JSON.stringify({ values, tableId, formType }),
      headers: { "Content-Type": "application/json" },
    });

    const resJson = await res.json();

    if (!res.ok) {
      return { success: false, error: resJson.error || "Form submission failed" };
    }

    return { success: true, data: resJson };
  } catch (error: any) {
    return { success: false, error: error.message || "Unknown error" };
  }
};
